<script>
import Vue from "vue";

export default {
    name: "VlboxResolutionField",
    props: ["propertyName", "value", "object", "options"],

    data() {
        return {
            selectedModeKey: "",
            applying: false,
            error: null
        };
    },

    computed: {
        modes() {
            return this.object?.remoteStatus?.display?.modes || [];
        },
        currentMode() {
            return this.modes.find(mode => mode.current);
        }
    },

    watch: {
        modes: {
            immediate: true,
            handler() {
                if (!this.selectedModeKey || !this.modes.some(mode => mode.modeKey === this.selectedModeKey)) {
                    this.selectedModeKey = this.currentMode?.modeKey || this.modes[0]?.modeKey || "";
                }
            }
        }
    },

    methods: {
        modeLabel(mode) {
            return `${mode.width}x${mode.height} @ ${mode.refreshHz}Hz` + (mode.preferred ? " (préférée)" : "");
        },
        async applyResolution() {
            if (!this.selectedModeKey || !this.object?._id) return;
            this.applying = true;
            this.error = null;
            try {
                await Vue.backoffice.requestor.post("/device/" + this.object._id + "/command", null, {
                    command: "set_resolution",
                    parameters: [this.selectedModeKey]
                });
            } catch (err) {
                console.error("Unable to apply resolution", err);
                this.error = "Échec de l'application de la résolution.";
            } finally {
                this.applying = false;
            }
        }
    }
};
</script>

<template>
    <div class="VlboxResolutionField">
        <div v-if="!object || !object._id" class="empty">Enregistrez la VLBox pour gérer sa résolution.</div>
        <div v-else-if="modes.length === 0" class="empty">Aucune résolution reportée par cette VLBox.</div>
        <div v-else class="resolution-picker">
            <span class="current">Actuelle : {{ currentMode ? modeLabel(currentMode) : "-" }}</span>
            <select v-model="selectedModeKey" :disabled="applying">
                <option v-for="mode in modes" :key="mode.modeKey" :value="mode.modeKey">
                    {{ modeLabel(mode) }}
                </option>
            </select>
            <button type="button" class="Button LittleButton Shy" :disabled="applying" @click="applyResolution">
                {{ applying ? "Application..." : "Appliquer" }}
            </button>
            <div v-if="error" class="error">{{ error }}</div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../packages/@snark/backoffice/src/sass/variables";

.VlboxResolutionField {
    .resolution-picker {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: $gap2;
    }

    .current {
        color: $textColor;
        font-size: 12px;
    }

    .error {
        flex: 0 0 100%;
        color: $error;
    }

    .empty {
        color: $textColor;
        padding: $gap2;
        background: $mainBackground;
        border-radius: 4px;
    }
}
</style>
